import React, { useContext, useEffect } from 'react'

import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'

import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'

import { auth } from '../../utils/firebase'

import _firebaseContext from '../../contexts/firebaseContext'
import _appContext from '../../contexts/appContext'

import AccessTime from '@material-ui/icons/AccessTime'
import PersonIcon from '@material-ui/icons/Person'
import ViewStreamIcon from '@material-ui/icons/ViewStream'
import DescriptionIcon from '@material-ui/icons/Description'

const useStyles = makeStyles(theme => ({
    content: {
        padding: theme.spacing(3, 1),
        paddingTop: 0,
        backgroundColor: theme.palette.background.paper,
        boxSizing: 'border-box',
        // width: '400px',
    },
    titleContainer: {
        paddingBottom: theme.spacing(2),
    },
    textCenter: {
        textAlign: 'center',
    },
    lens: {
        width: theme.spacing(4.5),
        height: theme.spacing(4.5),
        verticalAlign: 'super',
    },
    text: {
        ...theme.typography.body2,
        display: 'inline-block',
    },
    title: {
        ...theme.typography.h6,
        color: theme.palette.text.secondary,
        fontWeight: theme.typography.fontWeightBold,
        overflow: 'hidden',
        // textOverflow: 'ellipsis',
        // whiteSpace: 'nowrap',
    },
    container: {
        paddingBottom: theme.spacing(1.5),
    },
    grayIcon: {
        color: theme.palette.action.active,
    },
    icon: {
        verticalAlign: 'middle',
    },
    contentItemIcon: {
        textAlign: 'center',
        verticalAlign: 'middle',
    },
}))

export default function TooltipContent({ appointmentData, formatDate }) {
    const classes = useStyles()

    const firebaseContext = useContext(_firebaseContext)
    const appContext = useContext(_appContext)

    useEffect(() => {
        if (
            appointmentData.streamer.uid === auth().currentUser.uid &&
            firebaseContext.data.privateKeys[appointmentData.id] ===
                undefined &&
            firebaseContext.data.privateKeys[appointmentData.id] !== null
        ) {
            firebaseContext.getStreamKey(appointmentData.id).then(result => {
                // if (result.error) {
                //     appContext.snackbar.showSnackbarMsg(result.message);
                // }
            })
        }
    }, [])

    const copyStreamId = () => {
        navigator.clipboard
            .writeText(firebaseContext.data.privateKeys[appointmentData.id])
            .then(() => {
                appContext.snackbar.showSnackbarMsg('Id скопирован')
            })
    }

    return (
        <div className={classes.content}>
            <Grid
                container
                alignItems="center"
                className={classes.titleContainer}
            >
                <Grid item xs={2} className={classes.textCenter}>
                    {/* <Lens className={classes.lens} /> */}
                </Grid>
                <Grid item xs={10}>
                    <div>
                        <div
                            className={`${classes.title} ${classes.dateAndTitle}`}
                        >
                            {appointmentData.title}
                        </div>
                        <div
                            className={`${classes.text} ${classes.dateAndTitle}`}
                        >
                            {formatDate(appointmentData.startDate, {
                                day: 'numeric',
                                weekday: 'long',
                            })}
                        </div>
                    </div>
                </Grid>
            </Grid>
            <Grid container alignItems="center" className={classes.container}>
                <Grid item xs={2} className={classes.textCenter}>
                    <AccessTime
                        className={`${classes.icon} ${classes.grayIcon}`}
                    />
                </Grid>
                <Grid item xs={10}>
                    <div className={classes.text}>
                        {`${formatDate(appointmentData.startDate, {
                            hour: 'numeric',
                            minute: 'numeric',
                        })}
                    - ${formatDate(appointmentData.endDate, {
                        hour: 'numeric',
                        minute: 'numeric',
                    })}`}
                    </div>
                </Grid>
            </Grid>
            <Grid container alignItems="center" className={classes.container}>
                <Grid className={classes.contentItemIcon} item xs={2}>
                    <PersonIcon
                        className={`${classes.icon} ${classes.grayIcon}`}
                    />
                </Grid>
                <Grid className={classes.contentItemValue} item xs={10}>
                    <div className={classes.title}>
                        {appointmentData.streamer.name}
                    </div>
                </Grid>
            </Grid>
            <Grid container alignItems="center" className={classes.container}>
                <Grid className={classes.contentItemIcon} item xs={2}>
                    <DescriptionIcon
                        className={`${classes.icon} ${classes.grayIcon}`}
                    />
                </Grid>
                <Grid className={classes.contentItemValue} item xs={10}>
                    <div className={classes.title}>
                        {appointmentData.description}
                    </div>
                </Grid>
            </Grid>
            <Grid container alignItems="center" className={classes.container}>
                <Grid className={classes.contentItemIcon} item xs={2}>
                    <DescriptionIcon
                        className={`${classes.icon} ${classes.grayIcon}`}
                    />
                </Grid>
                <Grid className={classes.contentItemValue} item xs={10}>
                    <div className={classes.title}>
                        {`Статус стрима: ${appointmentData.streamStatus}`}
                    </div>
                </Grid>
            </Grid>
            {firebaseContext.data.privateKeys[appointmentData.id] !==
                undefined &&
                firebaseContext.data.privateKeys[appointmentData.id] !==
                    null && (
                    <Grid
                        container
                        alignItems="center"
                        className={classes.container}
                    >
                        <Grid className={classes.contentItemIcon} item xs={2}>
                            <Tooltip title="Копировать">
                                <IconButton onClick={copyStreamId}>
                                    <ViewStreamIcon
                                        className={`${classes.icon} ${classes.grayIcon}`}
                                    />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                        <Grid className={classes.contentItemValue} item xs={10}>
                            <Typography
                                color="textSecondary"
                                style={{ wordWrap: 'break-word' }}
                            >
                                {
                                    firebaseContext.data.privateKeys[
                                        appointmentData.id
                                    ]
                                }
                            </Typography>
                        </Grid>
                    </Grid>
                )}
        </div>
    )
}
